import { branch, renderComponent } from "recompose";

import SearchForm from "./Form";
import SearchRedirect from "./SearchRedirect";

export default branch(
  props => !!props.location.search,
  renderComponent(SearchRedirect)
)(SearchForm);
